import { render, staticRenderFns } from "./CustomerDetailsCardGeneralInformation.vue?vue&type=template&id=408a869a&scoped=true&"
import script from "./CustomerDetailsCardGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailsCardGeneralInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailsCardGeneralInformation.vue?vue&type=style&index=0&id=408a869a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a869a",
  null
  
)

export default component.exports